/**
 * Strips <quote> tags and markdown formatting for clean clipboard paste.
 */
function stripQuoteTags(text: string): string {
  return text.replace(/<\/?quote[^>]*>/gi, '');
}

/**
 * Strips markdown formatting (bold, italic, headers, links, etc.)
 */
function stripMarkdown(text: string): string {
  return text
    .replace(/\*\*(.+?)\*\*/g, '$1') // bold
    .replace(/\*(.+?)\*/g, '$1') // italic
    .replace(/__(.+?)__/g, '$1') // bold alt
    .replace(/_(.+?)_/g, '$1') // italic alt
    .replace(/#{1,6}\s?/g, '') // headers
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1') // links
    .replace(/`([^`]+)`/g, '$1') // inline code
    .replace(/```[\s\S]*?```/g, '') // code blocks
    .replace(/>\s?/gm, '') // blockquotes
    .trim();
}

/**
 * Formats a single section (title + body) for clipboard.
 */
export function formatSectionForClipboard(title: string, body: string): string {
  const cleanTitle = stripMarkdown(stripQuoteTags(title));
  const cleanBody = stripMarkdown(stripQuoteTags(body));
  return `${cleanTitle}\n${cleanBody}`;
}

/**
 * Formats an array of sections (e.g., themes, patterns) for clipboard.
 */
export function formatSectionsForClipboard(
  sections: Array<{ title: string; body: string }>,
): string {
  return sections
    .map((section, index) => {
      const cleanTitle = stripMarkdown(stripQuoteTags(section.title));
      const cleanBody = stripMarkdown(stripQuoteTags(section.body));
      return `${index + 1}. ${cleanTitle}\n${cleanBody}`;
    })
    .join('\n\n');
}

/**
 * Formats a summary text for clipboard.
 */
export function formatSummaryForClipboard(summary: string): string {
  return stripMarkdown(stripQuoteTags(summary));
}
